import styled from "styled-components";
import { Clickable, StandardTableSortableHeader, StandardTableSortablePropertyHeader, ThemedTableHeader } from "../../../components/tables/StandardTable";
import { usePersonalReminders } from "../hooks/PersonalRemindersContext";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { useMemo } from "react";

const ClickableHeader = styled(ThemedTableHeader)`
    ${Clickable}
`;

const PersonalReminderTableHeader = () => {

    const { sort, sortTable } = usePersonalReminders();

    return (
        <thead>
            <tr>
                <StandardTableSortablePropertyHeader
                    property="deadlineDate"
                    sort={sort}
                    sortTable={sortTable}
                    isSticky={true}
                >
                    Date
                </StandardTableSortablePropertyHeader>
                <StandardTableSortablePropertyHeader
                    property="type"
                    sort={sort}
                    sortTable={sortTable}
                    isSticky={true}
                >
                    Type
                </StandardTableSortablePropertyHeader>
                <StandardTableSortablePropertyHeader
                    property="masterAccountName"
                    sort={sort}
                    sortTable={sortTable}
                    isSticky={true}
                >
                    Account
                </StandardTableSortablePropertyHeader>
                <ThemedTableHeader>
                    Description
                </ThemedTableHeader>
                <ThemedTableHeader>
                    Notes
                </ThemedTableHeader>
                <StandardTableSortablePropertyHeader
                    property="userName"
                    sort={sort}
                    sortTable={sortTable}
                    isSticky={true}
                >
                    User
                </StandardTableSortablePropertyHeader>
                <StandardTableSortablePropertyHeader
                    property="status"
                    sort={sort}
                    sortTable={sortTable}
                    isSticky={true}
                    className="align-middle text-center"
                >
                    Status
                </StandardTableSortablePropertyHeader>
                <StandardTableSortablePropertyHeader
                    property="priority"
                    sort={sort}
                    sortTable={sortTable}
                    isSticky={true}
                    className="align-middle text-center"
                >
                    Priority
                </StandardTableSortablePropertyHeader>
            </tr>
        </thead>
    );
};

export default PersonalReminderTableHeader;